import { useState, useEffect } from 'react'
// Libs

// Constants

const useListFilter = ({ userList }: any) => {
  const [searchValue, setSearchValue] = useState('')
  const [filterUserList, setFilterUserList] = useState<any[]>([])

  useEffect(() => {
    if (userList?.length > 0) {
      const newUserList = userList.filter((item: any) => item.name.includes(searchValue))

      setFilterUserList(newUserList)
    }
  }, [searchValue])

  const handleSearchValueChange = (event: any) => {
    const value = event.target.value

    setSearchValue(value)
  }

  return { searchValue, handleSearchValueChange, filterUserList }
}

export default useListFilter
